module.exports = __webpack_public_path__ + "static/img/me-img3.a918123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/me-img3.png
// module id = ihI9
// module chunks = 0